module.exports = __webpack_public_path__ + "static/cheese-1-7ee3bea35e9828379f1790cea095b3a4.png";